import {Collapse, Table} from "antd";
import React from "react";
import {isDefined} from "../../../reducers/util";
import {Tracker} from "../../../types/Project";
import {O_AND, O_AND_AFTER, O_AND_BEFORE, O_AND_INDEX} from "../../Operator";
import styles from './TimeBetweenEvents.module.scss';
import './TimeBetweenEvents.scss';
import {Days} from "./icons/Days";
import {Months} from "./icons/Months";
import {TimeGreen} from "./icons/TimeGreen";
import {Weeks} from "./icons/Weeks";
import {CaretRightOutlined} from "@ant-design/icons";
import {ColumnsType} from "antd/es/table";

const {Panel} = Collapse

interface DataSourceType {
    unit: string | JSX.Element;
    std_dev: string | number | JSX.Element;
    mean: string | number | JSX.Element;
    median: string | number | JSX.Element;
    minimum: string | number | JSX.Element;
    maximum: string | number | JSX.Element;
    first_quartile: string | number | JSX.Element;
    third_quartile: string | number | JSX.Element;
    colSpan?: number;
}


const renderWithColSpan = (text: any, row: DataSourceType) => {
    if (row.colSpan) {
        return {
            children: null,
            props: {
                colSpan: 0,
            },
        };
    }
    return text;
};

const columns: ColumnsType<DataSourceType> = [
    {
        title: <b>Unit</b>,
        dataIndex: 'unit',
        key: 'unit',
    },
    {
        title: <b>Standard Deviation</b>,
        dataIndex: 'std_dev',
        key: 'std_dev',
        render: renderWithColSpan,
    },
    {
        title: <b>Mean</b>,
        dataIndex: 'mean',
        key: 'mean',
        render: renderWithColSpan,
    },
    {
        title: <b>Median</b>,
        dataIndex: 'median',
        key: 'median',
        render: renderWithColSpan,
    },
    {
        title: <b>Minimum</b>,
        dataIndex: 'minimum',
        key: 'minimum',
        render: (text: any, row: DataSourceType, index: number) => {
            return {
                children: text,
                props: {
                    colSpan: row.colSpan || 1,
                },
            };
        },
    },
    {
        title: <b>Maximum</b>,
        dataIndex: 'maximum',
        key: 'maximum',
        render: renderWithColSpan,
    },
    {
        title: <b>Lower Quartile</b>,
        dataIndex: 'first_quartile',
        key: 'first_quartile',
        render: renderWithColSpan,
    },
    {
        title: <b>Upper Quartile</b>,
        dataIndex: 'third_quartile',
        key: 'third_quartile',
        render: renderWithColSpan,
    },

];
const emptyDataSource = [
    {
        unit: <span><Days/> <b>Days</b></span>,
        std_dev: "",
        mean: "",
        median: "",
        minimum: "",
        maximum: "",
        first_quartile: "",
        third_quartile: "",
        colSpan: 7,
    },
    {
        unit: <span><Weeks/> <b>Weeks</b></span>,
        std_dev: "",
        mean: "",
        median: "",
        minimum: <span style={{display: 'block', textAlign: 'center'}}>
            Run a cohort with two events to view data explaining the time between them in days, weeks and months.</span>,
        maximum: "",
        first_quartile: "",
        third_quartile: "",
        colSpan: 7,
    },
    {
        unit: <span><Months/> <b>Months</b></span>,
        std_dev: "",
        mean: "",
        median: "",
        minimum: "",
        maximum: "",
        first_quartile: "",
        third_quartile: "",
        colSpan: 7,
    },
];

const extractTimeBetweenEventsData = (match: Tracker) => {
    const tbe = match.timeBetweenEvents
    const dataSource = [
        {
            unit: <span><Days/> <b>Days</b></span>,
            minimum: tbe.days[0],
            maximum: tbe.days[1],
            mean: tbe.days[2],
            first_quartile: tbe.days[3],
            median: tbe.days[4],
            third_quartile: tbe.days[5],
            std_dev: tbe.days[6],
        },
        {
            unit: <span><Weeks/> <b>Weeks</b></span>,
            minimum: tbe.weeks[0],
            maximum: tbe.weeks[1],
            mean: tbe.weeks[2],
            first_quartile: tbe.weeks[3],
            median: tbe.weeks[4],
            third_quartile: tbe.weeks[5],
            std_dev: tbe.weeks[6],
        },
        {
            unit: <span><Months/> <b>Months</b></span>,
            minimum: tbe.months[0],
            maximum: tbe.months[1],
            mean: tbe.months[2],
            first_quartile: tbe.months[3],
            median: tbe.months[4],
            third_quartile: tbe.months[5],
            std_dev: tbe.months[6],
        },
    ]
    return dataSource
}

export const TimeBetweenEvents: React.FC<{ id: string, operator: string[], trackers?: Tracker[] }> = ({
                                                                                                          id,
                                                                                                          operator,
                                                                                                          trackers
                                                                                                      }) => {
    const hasAndOperator = operator.findIndex(i => i === O_AND || i === O_AND_BEFORE || i === O_AND_AFTER || i === O_AND_INDEX) > -1
    let datasource = undefined
    if (trackers) {
        const match = trackers.find(i => i.id.startsWith(id + '__'))
        if (isDefined(match) && isDefined(match.timeBetweenEvents)) {
            datasource = extractTimeBetweenEventsData(match)
        }
    } else if (hasAndOperator) {
        datasource = emptyDataSource
    }
    if (datasource) {
        return <Collapse
            expandIcon={({isActive}) => <CaretRightOutlined data-testid={'time-between-events-toggle'}
                                                            rotate={isActive ? 90 : 0}
                                                            style={{color: '#568EEE', fontSize: '20px'}}/>}
            expandIconPosition={'end'}
            style={{marginTop: '10px'}}>
            <Panel header={<div className={styles.tableHeader}><TimeGreen size={5.4}/>&nbsp;Time Between Events</div>}
                   key={1}>
                <Table className={styles.table} pagination={false} bordered={true} dataSource={datasource}
                       columns={columns}/>
            </Panel>
        </Collapse>
    } else {
        return <></>
    }
}
